import { render, staticRenderFns } from "./CustomerTimelinePinnedEvent.vue?vue&type=template&id=58bf6979"
import script from "./CustomerTimelinePinnedEvent.vue?vue&type=script&lang=js"
export * from "./CustomerTimelinePinnedEvent.vue?vue&type=script&lang=js"
import style0 from "./CustomerTimelinePinnedEvent.vue?vue&type=style&index=0&id=58bf6979&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports